import { fetchRegistryEntries, RegistryEntry } from "@/services/registries/registriesAPI";
import { SavedObject } from "@/services/commonModels";

export async function fetchFermenterRegistryEntries(): Promise<RegistryEntry[]> {
    return fetchRegistryEntries("fermenter");
}

export type Container = SavedObject<number> & {
    experimentCode: string | null;
    containerTypeId: number | null;
    qrCode: string;
    usageTable: string | null;
    thingInstanceDataId: string | null;
    wells: Well[];
};

export type Well = SavedObject<number> & {
    repNum: number;
    qrCode: string;
    position: string;
    experimentAgentId: string | null;
    experimentTreatmentId: string | null;
    sprayerBarcode: string | null;
    location: Location | null;
    originalLocation: Location | null;
    thingInstanceDataId: string | null;
    containerId: number | null;
};
